const cards = [
    {
        size: {
            height: 1,
            width: 2,
        },
        type: 'background',
    },
    {
        options: {
            withImage: true,
        },
        size: {
            height: 1,
            width: 1,
        },
        type: 'article',
    },
    {
        size: {
            height: 1,
            width: 1,
        },
        type: 'article',
    },
    {
        size: {
            height: 1,
            width: 1,
        },
        type: 'article',
    },
    {
        size: {
            height: 1,
            width: 1,
        },
        type: 'article',
    },
    {
        options: {
            itemWidth: '276px',
            itemGap: '32px',
            slug: 'interesting-today',
        },
        size: {
            height: 0,
            width: 3,
        },
        type: 'slider',
    },
    {
        options: {
            withImage: true,
        },
        size: {
            height: 1,
            width: 1,
        },
        type: 'article',
    },
    {
        options: {
            withImage: true,
        },
        size: {
            height: 1,
            width: 1,
        },
        type: 'article',
    },
    {
        options: {
            withImage: true,
        },
        size: {
            height: 1,
            width: 1,
        },
        type: 'article',
    },
    {
        size: {
            height: 1,
            width: 1,
        },
        type: 'article',
    },
    {
        size: {
            height: 1,
            width: 1,
        },
        type: 'article',
    },
    {
        size: {
            height: 1,
            width: 1,
        },
        type: 'article',
    },
];
export default cards;
